<app-loader *ngIf="loading"></app-loader>
<div class="showcase-detail">
  <ng-container *ngIf="!loading">
    <div class="left" [ngStyle]="getBackgroundImage()">
      <div class="header">
        <div class="switch">
          <div [class.active]="isActivePictureTab()" (click)="setActiveTab(true)">
            {{ "PAGES.ALLOCATION.DIALOG.PICTURE" | translate }}
          </div>
          <div [class.active]="isActiveMapTab()" (click)="setActiveTab(false)">
            {{ "PAGES.ALLOCATION.DIALOG.MAP" | translate }}
          </div>
        </div>
      </div>
      <ng-container *ngIf="isActivePictureTab()">
        <ng-container *ngIf="!picture; else edit_picture">
          <ng-container *ngIf="isReadOnlyView()">
            <div class="uploader no-pic">
              <img src="./assets/images/placeholder_star.svg" alt="not uploaded">
              <div class="description">{{ "PAGES.ALLOCATION.DIALOG.UPLOAD.NO_PIC" | translate }}</div>
            </div>
          </ng-container>
          <ng-container *ngIf="!isReadOnlyView()">
            <div class="uploader" appDnd (fileDropped)="onFileDropped($event)">
              <img src="./assets/images/picture-2.svg" alt="upload a file">
              <div class="description">{{ "PAGES.ALLOCATION.DIALOG.UPLOAD.TITLE" | translate }}</div>
              <div class="formats">{{ "PAGES.ALLOCATION.DIALOG.UPLOAD.SUBTITLE" | translate }}</div>
              <input [disabled]="false" [accept]="ACCEPT_FILE" type="file" #fileDropRef id="fileDropRef" multiple
                (change)="fileBrowseHandler($event)" />
              <app-bulgari-button [type]="'primary'" (click)="null" [customStyle]="'text-transform: capitalize;'"
                [text]="'PAGES.ALLOCATION.DIALOG.UPLOAD.BUTTON1'"></app-bulgari-button>
            </div>
          </ng-container>

        </ng-container>
        <ng-template #edit_picture>
          <div class="edit">
            <app-bulgari-button *ngIf="!isReadOnlyView()" [type]="'flat'" (click)="handleEditClick()"
              [customStyle]="'text-transform: capitalize;'"
              [text]="'PAGES.ALLOCATION.DIALOG.UPLOAD.BUTTON2'"></app-bulgari-button>
          </div>
        </ng-template>
      </ng-container>
      <ng-container *ngIf="isActiveMapTab()">
        <app-map [showcaseCode]="getShowcaseCode()" [showcaseFloorCode]="getShowcaseFloorCode()"></app-map>
      </ng-container>
    </div>
    <div class="right">
      <div class="header">
        {{ "PAGES.ALLOCATION.DIALOG.TITLE" | translate }}
        <span (click)="closeDialog()" class="material-icons side-nav-bar-close">clear</span>
      </div>
      <div class="subtitle">
        {{getDescription()}}
      </div>
      <div class="products">
        <ng-container *ngFor="let product of getProducts(); let i = index">
          <app-product [product]="product" [showControls]="getShowControls(i)" [readOnly]="isReadOnlyView()"
            [disabled]="{left: i === 0, right: i === getProducts().length -1}" (handleShift)="shift($event, i)"
            (handleShowControls)="setShowControlsIndex(i)"></app-product>
        </ng-container>
      </div>
      <div class="footer" *ngIf="!isReadOnlyView()">
        <button class="cancel" (click)="cancel()">
          {{ 'PAGES.ALLOCATION.DIALOG.PRODUCTS.BUTTON1' | translate }}
        </button>
        <button (click)="save()" [disabled]="isDisabledSave()">
          {{ 'PAGES.ALLOCATION.DIALOG.PRODUCTS.BUTTON2' | translate }}
        </button>
      </div>
      <div class="footer" *ngIf="isReadOnlyView()">
        <button (click)="cancel()">
          {{ 'PAGES.ALLOCATION.DIALOG.PRODUCTS.BUTTON3' | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</div>
